app.directive('typeaheadFocus', [ function () {
  /*
    bootstrap typehead, does not show suggestion on focus or even
    adding some spaces at the end of the current selected string
    for example currently 'test' in selected and now if user click on input
    element we should show list of elements similar ot the curret selected one
    like 'test', 'test payer' etc
  */
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      //trigger the popup on 'click' because 'focus'
      //is also triggered after the item selection
      element.bind('click', function () {


        let viewValue = ngModel.$viewValue;
        //force trigger the popup if value is already selected
        if (viewValue) {
          ngModel.$setViewValue(' ');
          //set the actual value in case there was already a value in the input
          ngModel.$setViewValue(viewValue);
        }
      });

      //compare function that treats the empty space as a match
      scope.emptyOrMatch = function (actual, expected) {
        if (expected == ' ') {
          return true;
        }
        return actual.indexOf(expected) > -1;
      };
    }
  };
}]);
